export default {
  TRANSMISSION: "Transmission",

  A: "Automatic",
  M: "Manual",
};
